// extracted by mini-css-extract-plugin
module.exports = {"dialogOverlay":"dialog_dialogOverlay___ybYI","dialogContentContainer":"dialog_dialogContentContainer__yxk2S"};